import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeToolbarButton, { EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import serializers from './serializers';
import deserializers from './deserializers';
import EmbedBlock from './component';
import EmbedInner from '../../components/Embed';
import { EmbedIcon } from '../../components/Icons';
import makeLightboxItems from '../utils/makeLightboxItems';
import getBlockId from '../../utils/getBlockId';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.EMBED, {
    isVoid: true
  })
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$enableLightbox = _ref.enableLightbox,
      enableLightbox = _ref$enableLightbox === void 0 ? false : _ref$enableLightbox,
      iframelyApiKey = _ref.iframelyApiKey;

  return [normalizeNode(BlockTypes.EMBED, [shouldBeAtRoot]), _objectSpread({
    serializers: serializers,
    deserializers: deserializers,
    schema: schema
  }, renderBlocks(_defineProperty({}, BlockTypes.EMBED, function (props) {
    return React.createElement(EmbedBlock, Object.assign({
      enableLightbox: enableLightbox,
      iframelyApiKey: iframelyApiKey
    }, props));
  })), {
    commands: {
      addEmbed: function addEmbed(editor, url) {
        if (!url) {
          return editor;
        }

        return editor.insertBlock({
          type: BlockTypes.EMBED,
          data: {
            url: url
          }
        });
      }
    }
  }), makeToolbarButton(BlockTypes.EMBED, {
    icon: EmbedIcon,
    title: 'Embed',
    visibility: EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.EMBED);
    },
    onApply: function onApply(editor) {
      return editor.command('addEmbedPlaceholder');
    }
  }), makeKeyboardCommandShortcut('mod+alt+e', {
    type: BlockTypes.EMBED,
    command: 'addEmbedPlaceholder',
    byKey: false
  }), makeLightboxItems(BlockTypes.EMBED, {
    renderItem: function renderItem(itemData) {
      return React.createElement("div", {
        className: "width-full overflow-hidden radius-normal transition"
      }, React.createElement(EmbedInner, {
        iframelyApiKey: iframelyApiKey,
        url: itemData.url
      }));
    },
    getItems: function getItems(editor) {
      return editor.value.document.nodes.filter(function (node) {
        return node.type === BlockTypes.EMBED;
      }).map(function (node) {
        return {
          id: getBlockId(node),
          type: BlockTypes.EMBED,
          url: node.data.get('url'),
          width: 'auto',
          iframelyApiKey: iframelyApiKey
        };
      }).toJS();
    }
  })];
});